import React from "react";
import { createPortal } from "react-dom";
import styles from "./Modal.module.css";

const Modal = ({ children, closeModal, isOpen }) => {
  const rootModal = document.querySelector("#modal-root");

  const keyDownHandler = (e) => {
    if (e.key === "Escape") {
      closeModal();
    }
  };

  if (!isOpen || !rootModal) {
    return null;
  }

  return createPortal(
    <div className={styles.wrapper} tabIndex="0" onKeyDown={(e) => keyDownHandler(e)}>
      <div className={styles.bg} onClick={closeModal}></div>
      <button className={styles.closeBtn} onClick={closeModal}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-6 h-6"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
      <div className={styles.content}>{children}</div>
    </div>,
    rootModal
  );
};

export default Modal;
